import React, { Component } from 'react';
import { DeadlineBanner } from '../components/DeadlineBanner';
import { NewHero } from '../components/NewHero';
import { AtAGlance } from '../components/AtAGlance';
import { NewProblemSection } from '../components/NewProblemSection';
import { AlexandriaSection } from '../components/AlexandriaSection';
import { PSIGatheringSection } from '../components/PSIGatheringSection';
import { PSIProDifferenceSection } from '../components/PSIProDifferenceSection';
import { PSIProBenefitsSection } from '../components/PSIProBenefitsSection';
import { PeptideMasteryDetailSection } from '../components/PeptideMasteryDetailSection';
import { DirectAccessSection } from '../components/DirectAccessSection';
import { ApplicationAndPricingSection } from '../components/ApplicationAndPricingSection';
import { DeadlineAndPathsSection } from '../components/DeadlineAndPathsSection';
import { QualificationAndFAQSection } from '../components/QualificationAndFAQSection';
import { FinalPostscriptsSection } from '../components/FinalPostscriptsSection';
import { SolutionIntro } from '../components/SolutionIntro';
import { SolutionSection } from '../components/SolutionSection';
import { PeptideMasteryComponent } from '../components/PeptideMasteryComponent';
import { FreeOfferReveal } from '../components/FreeOfferReveal';
import { AdvancedIntelligenceAgency } from '../components/AdvancedIntelligenceAgency';
import { InvestmentSection } from '../components/InvestmentSection';
import { DeadlineScarcity } from '../components/DeadlineScarcity';
import { QualificationSection } from '../components/QualificationSection';
import { NoGuarantee } from '../components/NoGuarantee';
import { NewTestimonials } from '../components/NewTestimonials';
import { FAQSection } from '../components/FAQSection';
import { StakesSection } from '../components/StakesSection';
import { FinalCTA } from '../components/FinalCTA';
import { MysteryLayer } from '../components/MysteryLayer';
export function NewLandingPage() {
  return <div className="bg-black text-stone-200 min-h-screen relative" data-id="element-4348">
      <MysteryLayer data-id="element-4349" />
      <DeadlineBanner data-id="element-4350" />
      <NewHero data-id="element-4351" />
      <AtAGlance data-id="element-4352" />
      <NewProblemSection data-id="element-4353" />
      <AlexandriaSection data-id="element-4354" />
      <PSIGatheringSection data-id="element-4355" />
      <PSIProDifferenceSection data-id="element-4356" />
      <PSIProBenefitsSection data-id="element-4357" />
      <PeptideMasteryDetailSection data-id="element-4358" />
      <DirectAccessSection data-id="element-4359" />
      <ApplicationAndPricingSection data-id="element-4360" />
      <DeadlineAndPathsSection data-id="element-4361" />
      <QualificationAndFAQSection data-id="element-4362" />
      <FinalPostscriptsSection data-id="element-4363" />
      <SolutionIntro data-id="element-4364" />
      <SolutionSection data-id="element-4365" />
      <PeptideMasteryComponent data-id="element-4366" />
      <FreeOfferReveal data-id="element-4367" />
      <AdvancedIntelligenceAgency data-id="element-4368" />
      <InvestmentSection data-id="element-4369" />
      <DeadlineScarcity data-id="element-4370" />
      <QualificationSection data-id="element-4371" />
      <NoGuarantee data-id="element-4372" />
      <NewTestimonials data-id="element-4373" />
      <FAQSection data-id="element-4374" />
      <StakesSection data-id="element-4375" />
      <FinalCTA data-id="element-4376" />
    </div>;
}